"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var routes = {
  '/brands': {
    title: 'Brands',
    view: 'Brands',
    "public": true,
    locales: {
      az: '/az/brands',
      en: '/en/brands',
      ru: '/ru/brands'
    }
  },
  '/az/brands': {
    ref: '/brands',
    lang: 'az',
    title: 'Brendlər'
  },
  '/en/brands': {
    ref: '/brands',
    lang: 'en',
    title: 'Brands'
  },
  '/ru/brands': {
    ref: '/brands',
    lang: 'ru',
    title: 'Бренды'
  }
};
var _default = exports["default"] = routes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJyb3V0ZXMiLCJ0aXRsZSIsInZpZXciLCJsb2NhbGVzIiwiYXoiLCJlbiIsInJ1IiwicmVmIiwibGFuZyIsIl9kZWZhdWx0IiwiZXhwb3J0cyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL2xpYnJhcnkvc3JjLWNsaWVudC9tb2R1bGVzL0Vjb21tZXJjZS9CcmFuZC9CcmFuZFJvdXRlcy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCByb3V0ZXMgPSB7XG4gICAgJy9icmFuZHMnOiB7XG4gICAgICAgIHRpdGxlOiAnQnJhbmRzJyxcbiAgICAgICAgdmlldzogJ0JyYW5kcycsXG4gICAgICAgIHB1YmxpYzogdHJ1ZSxcbiAgICAgICAgbG9jYWxlczoge1xuICAgICAgICAgICAgYXo6ICcvYXovYnJhbmRzJyxcbiAgICAgICAgICAgIGVuOiAnL2VuL2JyYW5kcycsXG4gICAgICAgICAgICBydTogJy9ydS9icmFuZHMnLFxuICAgICAgICB9XG4gICAgfSxcbiAgICAnL2F6L2JyYW5kcyc6IHtyZWY6ICcvYnJhbmRzJywgbGFuZzogJ2F6JywgdGl0bGU6ICdCcmVuZGzJmXInfSxcbiAgICAnL2VuL2JyYW5kcyc6IHtyZWY6ICcvYnJhbmRzJywgbGFuZzogJ2VuJywgdGl0bGU6ICdCcmFuZHMnfSxcbiAgICAnL3J1L2JyYW5kcyc6IHtyZWY6ICcvYnJhbmRzJywgbGFuZzogJ3J1JywgdGl0bGU6ICfQkdGA0LXQvdC00YsnfSxcbn1cblxuZXhwb3J0IGRlZmF1bHQgcm91dGVzO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxJQUFNQSxNQUFNLEdBQUc7RUFDWCxTQUFTLEVBQUU7SUFDUEMsS0FBSyxFQUFFLFFBQVE7SUFDZkMsSUFBSSxFQUFFLFFBQVE7SUFDZCxVQUFRLElBQUk7SUFDWkMsT0FBTyxFQUFFO01BQ0xDLEVBQUUsRUFBRSxZQUFZO01BQ2hCQyxFQUFFLEVBQUUsWUFBWTtNQUNoQkMsRUFBRSxFQUFFO0lBQ1I7RUFDSixDQUFDO0VBQ0QsWUFBWSxFQUFFO0lBQUNDLEdBQUcsRUFBRSxTQUFTO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFVLENBQUM7RUFDN0QsWUFBWSxFQUFFO0lBQUNNLEdBQUcsRUFBRSxTQUFTO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFRLENBQUM7RUFDM0QsWUFBWSxFQUFFO0lBQUNNLEdBQUcsRUFBRSxTQUFTO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFRO0FBQzlELENBQUM7QUFBQSxJQUFBUSxRQUFBLEdBQUFDLE9BQUEsY0FFY1YsTUFBTSIsImlnbm9yZUxpc3QiOltdfQ==